module.exports = __webpack_public_path__ + "static/ts2365-f247b53039597605584d4e69228ee72b.png";